module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Role Information",
      "name": "first"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "RoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sRoleName", $$v)
      },
      expression: "filters.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.filters.sState),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sState", $$v)
      },
      expression: "filters.sState"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.reGetList()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addRoleFlag = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAdd Role\n\t\t\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "row-click": _vm.toDetailRole,
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sRoleName",
      "label": "Role Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sRoleDescribe",
      "label": "Role Description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sState",
      "label": "Status",
      "formatter": _vm.sState
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.tableData3.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "float": "left"
    }
  }, [(_vm.filters.sState == 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tInactive\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.filters.sState == 0) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.toggleSelection(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tActive\n\t\t\t\t\t")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Roles",
      "visible": _vm.addRoleFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addRoleFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "sRoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRoleName", $$v)
      },
      expression: "form.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.roles),
      callback: function($$v) {
        _vm.$set(_vm.form, "roles", $$v)
      },
      expression: "form.roles"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.id,
      attrs: {
        "label": a.name
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role Describe",
      "prop": "sRoleDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sRoleDescribe),
      callback: function($$v) {
        _vm.$set(_vm.form, "sRoleDescribe", $$v)
      },
      expression: "form.sRoleDescribe"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addRoleFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Edit Roles",
      "visible": _vm.EditRoleFlag,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.EditRoleFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "detailForm",
    attrs: {
      "model": _vm.detailForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role Name",
      "prop": "sRoleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sRoleName),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sRoleName", $$v)
      },
      expression: "detailForm.sRoleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Authority"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.detailForm.roles),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "roles", $$v)
      },
      expression: "detailForm.roles"
    }
  }, _vm._l((_vm.options3), function(a) {
    return _c('el-checkbox', {
      key: a.id,
      attrs: {
        "label": a.name
      }
    }, [_vm._v(_vm._s(a.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Role Describe",
      "prop": "sRoleDescribe"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.detailForm.sRoleDescribe),
      callback: function($$v) {
        _vm.$set(_vm.detailForm, "sRoleDescribe", $$v)
      },
      expression: "detailForm.sRoleDescribe"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.EditRoleFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "User Related",
      "name": "second"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters2.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters2, "nRoleId", $$v)
      },
      expression: "filters2.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change2
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod2,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList2
    },
    model: {
      value: (_vm.filters2.nUserIds),
      callback: function($$v) {
        _vm.$set(_vm.filters2, "nUserIds", $$v)
      },
      expression: "filters2.nUserIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save2
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Data Source Related",
      "name": "third"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters3,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters3.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters3, "nRoleId", $$v)
      },
      expression: "filters3.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change3
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod3,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList3
    },
    model: {
      value: (_vm.filters3.nSelectIds),
      callback: function($$v) {
        _vm.$set(_vm.filters3, "nSelectIds", $$v)
      },
      expression: "filters3.nSelectIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save3
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Table Management",
      "name": "fourth"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters4,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters4.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters4, "nRoleId", $$v)
      },
      expression: "filters4.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change4
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData4
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sSchemaName",
      "label": "Schema"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sSelectName",
      "label": "SelectName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "valueStatus",
      "label": "valueStatus",
      "formatter": _vm.valueStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fieldStatus",
      "label": "fieldStatus",
      "formatter": _vm.fieldStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operation"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "icon": "el-icon-date"
          },
          on: {
            "click": function($event) {
              return _vm.changeDetail1(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "icon": "el-icon-edit-outline"
          },
          on: {
            "click": function($event) {
              return _vm.changeDetail2(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.ViewFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ViewFlag = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('a', {
    staticStyle: {
      "font-size": "20px",
      "margin-right": "30px"
    }
  }, [_vm._v("Value Management")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addView
    }
  }, [_vm._v("Add+")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, _vm._l((_vm.ViewForm.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": "Column Name.",
        "prop": "selectColumnList"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnCode),
        callback: function($$v) {
          _vm.$set(item, "sColumnCode", $$v)
        },
        expression: "item.sColumnCode"
      }
    }, _vm._l((_vm.ViewOptions), function(item) {
      return _c('el-option', {
        key: item.sColumnCode,
        attrs: {
          "label": item.sColumnName,
          "value": item.sColumnCode
        }
      })
    }), 1), _vm._v(" "), _c('label', [_vm._v("Value.")]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "placeholder": ""
      },
      model: {
        value: (item.sColumnValue),
        callback: function($$v) {
          _vm.$set(item, "sColumnValue", $$v)
        },
        expression: "item.sColumnValue"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteView(index)
        }
      }
    }, [_vm._v("Delete-")])], 1)
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ViewFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveViewFlag
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": " Field Management",
      "visible": _vm.ViewFieldFlag,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.ViewFieldFlag = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "border": "",
      "size": "medium",
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.ViewFieldForm.list),
      callback: function($$v) {
        _vm.$set(_vm.ViewFieldForm, "list", $$v)
      },
      expression: "ViewFieldForm.list"
    }
  }, _vm._l((_vm.ViewOptions), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "border": "",
        "size": "medium",
        "label": item.sColumnCode
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.ViewFieldFlag = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveViewFieldFlag
    }
  }, [_vm._v("Confirm")])], 1)])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Template Related",
      "name": "fivth"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters5,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Role"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.filters5.nRoleId),
      callback: function($$v) {
        _vm.$set(_vm.filters5, "nRoleId", $$v)
      },
      expression: "filters5.nRoleId"
    }
  }, _vm._l((_vm.totalRoleList), function(item) {
    return (item.nRoleId != 1) ? _c('el-option', {
      key: item.nRoleId,
      attrs: {
        "label": item.sRoleName,
        "value": item.nRoleId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.change5
    }
  }, [_vm._v("Search")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-transfer', {
    attrs: {
      "filterable": "",
      "filter-method": _vm.filterMethod5,
      "titles": ['Unselect', 'Select'],
      "filter-placeholder": "Name",
      "data": _vm.leftRoleList5
    },
    model: {
      value: (_vm.filters5.nTemplateIds),
      callback: function($$v) {
        _vm.$set(_vm.filters5, "nTemplateIds", $$v)
      },
      expression: "filters5.nTemplateIds"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.save5
    }
  }, [_vm._v("Save")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8302f560"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/role.vue
// module id = 677
// module chunks = 1